/**
 * Product Video Autoplay + Loop
 * Makes Shopify-hosted product videos in the product gallery autoplay (muted) and loop.
 * Plays when in view, pauses when scrolled away.
 */
(function () {
  if (window.__productVideoAutoplay) return;
  window.__productVideoAutoplay = true;

  var SELECTOR = '.product__images video';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.25 });

  function prep(v) {
    if (v.dataset.autoloop) return;
    v.dataset.autoloop = '1';

    // Required for autoplay on Chrome/Safari/iOS
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.loop = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('loop', '');
    v.setAttribute('preload', 'auto');

    // Clean, GIF-like look. Delete this line to keep the player controls.
    v.removeAttribute('controls');

    // Safety net in case theme JS strips the loop attribute
    v.addEventListener('ended', function () {
      v.currentTime = 0;
      v.play().catch(function () {});
    });

    io.observe(v);
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(prep);
  }

  function init() {
    scan();
    // Catch videos injected later (variant switch, lazy-loaded media, quick view)
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();